import { Box } from "@mui/material";
import FilterComponent from "../../../ReusableFIlterComponent/FilterComponent";

const SELECTED_COLOR = "#9C27B0";
const UNSELECTED_COLOR = "#000000DE";

export interface FilterOption {
  label: string;
  value: string;
}

interface Props {
  interfaceOptions: FilterOption[];
  selectedInterfaces: string[];
  onSelectedInterfacesChange: (value: string[]) => void;
  reportOptions: FilterOption[];
  selectedReports: string[];
  onSelectedReportsChange: (value: string[]) => void;
  onClearFilters: () => void;
}

/**
 * The Configs filter set. Both filters are id-valued, so they are passed as
 * explicit `options` (label/value pairs) rather than derived from the rows -
 * otherwise the popup would list bare interface and report ids.
 *
 * FilterComponent owns the `configFilters` query param and resets `page` when a
 * selection changes; it also renders the Clear Filter button.
 */
const ConfigsFilterItems = ({
  interfaceOptions,
  selectedInterfaces,
  onSelectedInterfacesChange,
  reportOptions,
  selectedReports,
  onSelectedReportsChange,
  onClearFilters,
}: Props) => {
  const filterConfig = [
    {
      key: "iface",
      name: "Interface",
      label: "Select an Interface",
      selectedOption: selectedInterfaces,
      filterName: "iface",
      options: interfaceOptions,
      onSelectionChange: onSelectedInterfacesChange,
      count: selectedInterfaces.length,
      colorSelected:
        selectedInterfaces.length > 0 ? SELECTED_COLOR : UNSELECTED_COLOR,
      multiSelect: true,
      showSearch: true,
      trackerId: "1096",
    },
    {
      key: "report",
      name: "Report",
      label: "Select a Report",
      selectedOption: selectedReports,
      filterName: "report",
      options: reportOptions,
      onSelectionChange: onSelectedReportsChange,
      count: selectedReports.length,
      colorSelected:
        selectedReports.length > 0 ? SELECTED_COLOR : UNSELECTED_COLOR,
      multiSelect: true,
      showSearch: true,
      trackerId: "1097",
    },
  ];

  return (
    <Box>
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={onClearFilters}
        filterNameURL="configFilters"
        clearFilterTrackerId="1098"
      />
    </Box>
  );
};

export default ConfigsFilterItems;
